import { StatusDot } from "@/components/ui";
import { ToastReplyBox } from "@/components/toasts/toast-reply-box";
import type { WorkToastQuestion } from "@/stores/work-toast-store";
import { CompactCursorPillQuestionLayout } from "./compact-cursor-pill-question-layout";
import { useT } from "@/i18n";
import { compactCursorMessages } from "@/i18n/messages/compact-cursor";

const noop = () => {};

/** Inert visual twin: keeps option and reply geometry without a dictation claim. */
export function CompactCursorPillQuestionMeasure({
  question,
  showReply,
  draft,
}: {
  question: WorkToastQuestion;
  showReply: boolean;
  draft: string;
}) {
  const t = useT(compactCursorMessages);
  return (
    <span className="flex items-start gap-1.5">
      <StatusDot tone="question" className="mt-[5px]" />
      <CompactCursorPillQuestionLayout
        question={question}
        disabled
        onPickOption={noop}
        optionTestIdPrefix="compact-cursor-pill-measure-option"
        showReply={showReply}
        reply={
          <ToastReplyBox
            testId="compact-cursor-pill-measure-reply"
            value={draft}
            onChange={noop}
            onSend={noop}
            placeholder={t("yourAnswer")}
            sending
            mic={{ recording: false, disabled: true, onClick: noop }}
          />
        }
      />
    </span>
  );
}
